<template>
  <v-container fluid>
    <div class="d-flex mb-4">
      <h1 class="text-h4">
        <v-icon left>
          fal fa-envelope
        </v-icon>
        Email Templates
      </h1>
      <v-spacer></v-spacer>
      <v-btn :href="`https://app.mobilelocker.com/shared/how-to-create-your-own-email-templates-in-mobile-locker?email=${user.email}`"
             target="_blank"
             class="mr-4">
        Watch Video
      </v-btn>
      <v-btn :to="{name: `${$root.routePrefix}.share_template.create`}"
             color="primary">
        New Template
      </v-btn>
    </div>

    <v-card class="mb-4">
      <v-card-title class="pb-0">
        My Templates
      </v-card-title>
      <member-share-templates-table :loading="loading"
                                    :templates="myTemplates"
                                    class="pb-4">
      </member-share-templates-table>
    </v-card>

    <v-card>
      <v-card-title class="pb-0">
        Other Templates
      </v-card-title>
      <member-share-templates-table :loading="loading"
                                    :templates="otherTemplates"
                                    class="pb-4">
      </member-share-templates-table>
    </v-card>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import shareTemplateService from '../../../../../ml/services/shareTemplateService';
import MemberShareTemplatesTable from './MemberShareTemplatesTable';

export default {
  components: {MemberShareTemplatesTable},
  data() {
    return {
      form: new Form({}),
      loading: false,
      templates: [],
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isMember',
      'team',
      'user',
    ]),
    myTemplates() {
      return this.templates.filter(t => {
        return t.is_tinymce && t.user_id === this.user.id;
      });
    },
    otherTemplates() {
      return this.templates.filter(t => {
        if (t.user_id === this.user.id) {
          return false;
        }
        if (!t.can_be_copied) {
          return false;
        }
        if (!t.is_active_released_not_expired) {
          return false;
        }
        if (t.is_quick_share) {
          return false;
        }
        if (t.is_tinymce === false) {
          return false;
        }
        return true;
      });
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      shareTemplateService.getTemplatesForUser()
        .then(data => {
          this.templates = data;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }
}
</script>
